import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";

export default function ProfileModelPortfolio({
  edittype,
  formData,
  setFormData,
  setModalPortfolio,
}) {
  // const [formData, setFormData] = useState(profile);
  const [validation, setValidation] = useState(false);
  const [popularSkills, setPopularSkills] = useState("");
  const [allSkills, setAllSkills] = useState("");
  const [selectSkills, setSelectSkills] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState(formData.skills || []);
  const [manualSkill, setManualSkill] = useState("");
  const [addmanual, setAddmanual] = useState(false);

  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);
  const dispatch = useDispatch();

  useEffect(() => {
    setAllSkills(skillsss);
    setPopularSkills(skillsss);
  }, [skillsss]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    setSelectedSkills([...selectedSkills, newLanguage]);
    setSelectSkills(null);
  };

  const handleAddPopularSkill = (skill) => {
    const newSkill = {
      id: skill.id,
      title: skill.title,
    };
    setSelectedSkills([...selectedSkills, newSkill]);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = selectedSkills.filter(
      (language) => language.id !== id,
    );
    setSelectedSkills(updatedLanguages);
  };

  const handleAddManualSkill = () => {
    if (manualSkill.trim() == "") return;
    const newSkill = {
      id: manualSkill.trim(),
      title: manualSkill.trim(),
    };
    setSelectedSkills([...selectedSkills, newSkill]);
    setManualSkill("");
    setAddmanual(false);
  };

  const handleSave = () => {
    if (selectedSkills.length >= 3) {
      setFormData((prevData) => ({
        ...prevData,
        skills: selectedSkills,
      }));

      const data = {
        type: "skills",
        skills: selectedSkills,
      };
      if (edittype == 1) {
        dispatch(updateProfile(data));
        setModalPortfolio((state) => !state);
      }

      setModalPortfolio((state) => !state);
    } else {
      setValidation(true);
    }
  };

  return (
    <>
      <button
        onClick={() => setModalPortfolio((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Competencies</h4>
        <div>
          <div className="form-group">
            <label className="label">Search or add competencies</label>
            <ReactSelect
              options={
                Array.isArray(allSkills) &&
                allSkills
                  .filter(
                    (lang) =>
                      !selectedSkills.some(
                        (selectedLang) => selectedLang.id === lang.id,
                      ),
                  )
                  .map((lang) => ({ value: lang.id, label: lang.title }))
              }
              placeholder="Select competencies"
              isClearable={true}
              value={selectSkills}
              onChange={(options) => {
                if (options) {
                  handleLanguageChange(options);
                }
              }}
            />
            <p>Add up to 5 competencies for best results</p>

            {validation && (
              <p style={{ color: "red" }}>Please add at least 3 skills</p>
            )}
            <button
              className="add-plus btn"
              onClick={() => {
                setAddmanual(true);
              }}
            >
              + Add competencies Manually
            </button>
            {addmanual && (
              <div className="manualskill-input mb-3">
                <input
                  type="text"
                  value={manualSkill}
                  onChange={(e) => setManualSkill(e.target.value)}
                  placeholder="Type a competencies"
                  className="form-control"
                  style={{ width: "65%" }}
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      e.preventDefault();
                      handleAddManualSkill();
                    }
                  }}
                />
                <button type="button" onClick={handleAddManualSkill}>
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setAddmanual(false);
                  }}
                >
                  Close
                </button>
              </div>
            )}

            <div className="add-skills">
              {Array.isArray(selectedSkills) &&
                selectedSkills.map((skills, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      handleDeleteLanguage(skills.id);
                    }}
                  >
                    <p>
                      {skills.title} <span>x</span>
                    </p>
                  </div>
                ))}
            </div>
            <div className="popular-skill">
              <h5 className="mt-2">Popular competencies based on your designation</h5>
              <div className="add-skills">
                {Array.isArray(popularSkills) &&
                  popularSkills
                    .filter(
                      (lang) =>
                        !selectedSkills.some(
                          (selectedLang) => selectedLang.id === lang.id,
                        ),
                    )
                    .map((skills, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          handleAddPopularSkill(skills);
                        }}
                      >
                        <p
                          className="select-deactive-skill"
                        >
                          {skills.title} <span>+</span>
                        </p>
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
